// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace LeaseActivityConfig{
    export const UNITS_PER_PAGE = 11;
}
